<template>
  <el-drawer
    title="Detalles GPS Navision"
    :visible="DriwerVisible"
    size="70%"
    append-to-body
    @close="Onclose"
  >
    <el-row>
      <TableContracts ref="contracts" :clientCode="Cliente" />
    </el-row>
  </el-drawer>
</template>

<script>
import TableContracts from "./TableContracts.vue";

export default {
  components: { TableContracts },
  name: "DrawerGpsNavision",
  props: {
    visible: {
      typeof: Boolean,
      default: false
    },
    Client: {
      typeof: String,
      default: ""
    }
  },
  data() {
    return {
      DriwerVisible: false,
      Cliente: ""
    };
  },

  methods: {
    Onclose() {
      this.DriwerVisible = false;
      this.$emit("CloseGPSNavision", false);
    }
  },

  watch: {
    visible(newValue) {
      if (newValue) {
        this.DriwerVisible = this.visible;
      }
    },

    Client(newValue) {
      this.Cliente = newValue;
    }
  }
};
</script>
